import { render, staticRenderFns } from "./SpinnerWave.vue?vue&type=template&id=418790bc&scoped=true"
import script from "./SpinnerWave.vue?vue&type=script&lang=js"
export * from "./SpinnerWave.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWave.vue?vue&type=style&index=0&id=418790bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418790bc",
  null
  
)

export default component.exports